import generateStore from './generateStore.js'
import { axios } from '../request'

// OIDC client registration store (issue #43). Standard CRUD against
// /oidc_clients, plus a rotate-secret action. The one-time secret arrives in the
// create/rotate response as `_revealed` (full length) and is shown once in the
// UI, mirroring apiSecrets.
export default (app) => {
  const store = generateStore('oidcClients', app)

  // Rotate the client secret: POST /oidc_clients/:id/rotate. The response carries
  // the new full secret once; inject it into the displayed record (key 0) so the
  // one-time reveal block renders it. The persisted server row keeps only a prefix.
  store.actions.rotateSecret = (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`oidc_clients/${id}/rotate`)
        .then((res) => {
          context.commit('setSingle', { key: 0, data: res.data.data, listName: 'default' })
          resolve(res.data.data)
        })
        .catch((err) => reject(err))
    })
  }

  return store
}
